import { render, staticRenderFns } from "./watchlist.vue?vue&type=template&id=288f952e&scoped=true&"
import script from "./watchlist.vue?vue&type=script&lang=js&"
export * from "./watchlist.vue?vue&type=script&lang=js&"
import style0 from "./watchlist.vue?vue&type=style&index=0&id=288f952e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f952e",
  null
  
)

export default component.exports